import { render, staticRenderFns } from "./giftWall.vue?vue&type=template&id=722512b2&scoped=true"
import script from "./giftWall.vue?vue&type=script&lang=js"
export * from "./giftWall.vue?vue&type=script&lang=js"
import style0 from "./giftWall.vue?vue&type=style&index=0&id=722512b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722512b2",
  null
  
)

export default component.exports